<!-- <link rel="stylesheet" type="text/css" href="detailview.component.scss" /> -->
<div id="detailviewSwitcherTriggerWrapper" [style.left.px]="isShownDetailView() ? -25 : -35">
  <div id="detailviewSwitcherTrigger" class="cursor-pointer" (click)="toggleDetailViewIsShown()">
    <a href="javascript:void(0);" class="cursor-pointer">
      <cds-icon size="32" shape="angle-double" [direction]="isShownDetailView() ? 'right' : 'left'" />
    </a>
  </div>
</div>

<div id="detailviewwrapper" #detailviewwrapper [style.padding-bottom.px]="progressbarenlarged ? 75 : 0">
  @if (!(loading | async)) {
    <div class="h-100">
      <div style="display: flex; flex-flow: row-reverse nowrap; justify-content: space-between">
        <cds-icon
          size="20"
          shape="times"
          (click)="closeHandler()"
          class="cursor-pointer"
          [attr.title]="'Schließen' | mrTranslate" />
        @if (showProtected) {
          <clr-button-group class="btn-icon detailViewToolbar wrap-button set-width" [clrMenuPosition]="'bottom-right'">
            <ng-container *w-media-query="{ min: 1056 }">
              <clr-button (click)="expand('full')">
                <cds-icon
                  shape="angle"
                  size="20"
                  [title]="'Vollbild' | mrTranslate"
                  [direction]="expanded ? 'right' : 'left'" />
              </clr-button>
              <clr-button (click)="expand('half')">
                <cds-icon [title]="'Splitscreen' | mrTranslate" size="20" shape="map" [solid]="split50" />
              </clr-button>
            </ng-container>
            @if (rechte() == 2 && progVersion == 45 && authService?.token?.rights?.status > 4 && !isFatObject()) {
              <clr-button
                (click)="createInspektion(false)"
                [disabled]="deactivateAll || deactivateRep || isFatUiLimited">
                <cds-icon [title]="'Neue Inspektion' | mrTranslate" size="20" shape="inspektion" />
              </clr-button>
            }
            @if (authService?.token?.rights?.dev == true) {
              <clr-button
                (click)="createInspektion(true)"
                [disabled]="deactivateAll || !opruefid || deactivateRep || isFatUiLimited">
                <cds-icon [title]="'Inspektion bearbeiten' | mrTranslate" size="20" shape="editInsp" />
              </clr-button>
            }
            @if (
              rechte() == 2 && showProtected.assignment && authService?.token?.rights?.status > 2 && !isFatObject()
            ) {
              <clr-button
                (click)="createAssignment()"
                [disabled]="!hasOpenMangel || deactivateAll || isRep || isFatUiLimited">
                <!-- || isRep || deactivateRep -->
                <cds-icon [title]="'Auftrag erstellen' | mrTranslate" size="20" shape="pinboard" />
              </clr-button>
            }
            @if (rechte() == 2 && showProtected.feedback && authService?.token?.rights?.status > 2 && !isFatObject()) {
              <clr-button
                (click)="createFeedback()"
                [disabled]="opruefid == 0 || deactivateAll || isRep || deactivateRep || isFatUiLimited">
                <cds-icon [title]="'Rückmeldung anlegen' | mrTranslate" size="20" shape="redo" />
              </clr-button>
            }
            @if (
              rechte() == 2 && showProtected.interference && authService?.token?.rights?.status > 2 && !isFatObject()
            ) {
              <clr-button (click)="createDefect()" [disabled]="deactivateAll || isFatUiLimited">
                <cds-icon [title]="'Störung anlegen' | mrTranslate" size="19" shape="warning-standard" />
              </clr-button>
            }
            @if (rechte() == 2 && showProtected.blockings && authService?.token?.rights?.status > 2 && !isFatObject()) {
              <clr-button (click)="createBlocking()" [disabled]="deactivateAll || isFatUiLimited">
                <cds-icon [title]="'Sperrung anlegen' | mrTranslate" size="20" shape="times-circle" />
              </clr-button>
            }
            @if (
              rechte() == 2 &&
              showProtected.speedRestrictions &&
              authService?.token?.rights?.status > 2 &&
              !isFatObject()
            ) {
              <clr-button (click)="createLAStelle()" [disabled]="deactivateAll || isFatUiLimited">
                <cds-icon
                  [title]="'Langsamfahrstelle anlegen' | mrTranslate"
                  size="20"
                  shape="lastelle"
                  class="margin-3-t" />
              </clr-button>
            }
            <ng-container [el-media-query]="{ max: 655, el: detailviewwrapper }" debounce_time="10" #q="query">
              @if (rechte() == 2 && authService?.token?.rights?.status > 2 && STEDIT == true) {
                <clr-button
                  [clrInMenu]="!isFatObject() && (q.matches || (!split50 && !expanded))"
                  (click)="editStammdaten()"
                  [disabled]="deactivateAll || deactivateRep || isFatUiLimited">
                  <cds-icon [title]="'Stammdaten bearbeiten' | mrTranslate" size="20" shape="form" class="margin-3-t" />
                  <span class="clr-icon-title">&nbsp;{{ 'Stammdaten' | mrTranslate }}</span>
                </clr-button>
              }
              @if (rechte() == 2 && authService?.token?.rights?.status > 2 && SPEDIT == true) {
                <clr-button
                  [clrInMenu]="!isFatObject() && (q.matches || (!split50 && !expanded))"
                  (click)="createSpezifikationen()"
                  [disabled]="deactivateAll || deactivateRep || isFatUiLimited">
                  <cds-icon [title]="'Spezifikation bearbeiten' | mrTranslate" size="20" shape="list" />
                  <span class="clr-icon-title">&nbsp;{{ 'Spezifikation' | mrTranslate }}</span>
                </clr-button>
              }

              @if (rechte() == 2) {
                <clr-button
                  [clrInMenu]="!isFatObject() && (q.matches || (!split50 && !expanded))"
                  (click)="openHerstellModal()"
                  [disabled]="deactivateAll || deactivateRep">
                  <cds-icon
                    [title]="'Herstelldaten' | mrTranslate"
                    size="20"
                    shape="factory"
                    [style.color]="!hasSelectedSpez ? 'gray' : ''" />
                  <span class="clr-icon-title">&nbsp;{{ 'Herstelldaten' | mrTranslate }}</span>
                </clr-button>
              }
              @if (rechte() == 2 && typ_Line_Point == 4 && authService?.token?.rights?.status > 2 && BWEDIT == true) {
                <clr-button
                  [clrInMenu]="q.matches || (!split50 && !expanded)"
                  (click)="getBauwerke()"
                  [disabled]="deactivateAll || deactivateRep">
                  <cds-icon [title]="'Bauwerke' | mrTranslate" size="20" shape="bauwerke" />
                  <span class="clr-icon-title">&nbsp;{{ 'Bauwerke' | mrTranslate }}</span>
                </clr-button>
              }
              @if (
                rechte() == 2 &&
                typ_Line_Point == 4 &&
                authService?.token?.rights?.status > 2 &&
                objOpt?.Opt_F_Naturschutz == 1
              ) {
                <clr-button
                  [clrInMenu]="q.matches || (!split50 && !expanded)"
                  (click)="getNaturschutz()"
                  [disabled]="deactivateAll || deactivateRep">
                  <cds-icon [title]="'Naturschutz' | mrTranslate" size="20" shape="naturschutz" />
                  <span class="clr-icon-title">&nbsp;{{ 'Naturschutz' | mrTranslate }}</span>
                </clr-button>
              }
              @if (rechte() == 2 && typ_Line_Point == 4 && authService?.token?.rights?.status > 2) {
                <clr-button
                  [clrInMenu]="q.matches || (!split50 && !expanded)"
                  (click)="getEreignis()"
                  [disabled]="deactivateAll || deactivateRep">
                  <cds-icon [title]="'Ereignis' | mrTranslate" size="20" shape="tags" />
                  <span class="clr-icon-title">&nbsp;{{ 'Ereignis' | mrTranslate }}</span>
                </clr-button>
              }
              @if (rechte() == 2 && objOpt?.Opt_F_BUESicht == 1 && authService?.token?.rights?.status > 2) {
                <clr-button
                  [disabled]="!opruefid"
                  [clrInMenu]="q.matches || (!split50 && !expanded)"
                  (click)="getBahnuebergaenge()">
                  <cds-icon [title]="'Bahnuebergaenge' | mrTranslate" size="20" shape="bahnuebergang" />
                  <span class="clr-icon-title">&nbsp;{{ 'Bahnübergänge' | mrTranslate }}</span>
                </clr-button>
              }
              @if (typ_Line_Point | objtype: 'line') {
                @if (!isRep) {
                  @if (hasProfilmessung) {
                    <clr-button [clrInMenu]="q.matches || (!split50 && !expanded)" (click)="getProfile()">
                      <cds-icon [title]="'Profil-Viewer' | mrTranslate" size="20" shape="line-chart" />
                      <span class="clr-icon-title">&nbsp;{{ 'Profil-Viewer' | mrTranslate }}</span>
                    </clr-button>
                  }
                  <clr-button
                    [clrInMenu]="q.matches || (!split50 && !expanded)"
                    (click)="getMessungen()"
                    [disabled]="!hasGleismessung">
                    <cds-icon [title]="'Messungen' | mrTranslate" size="19" shape="ruler-pencil" />
                    <span class="clr-icon-title">&nbsp;{{ 'Messungen' | mrTranslate }}</span>
                  </clr-button>
                  <clr-button
                    [clrInMenu]="q.matches || (!split50 && !expanded)"
                    (click)="getMessungenLWM()"
                    [disabled]="!hasRiffelMessung">
                    <cds-icon [title]="'Längswelligkeitsmessungen' | mrTranslate" size="19" shape="tick-chart" />
                    <span class="clr-icon-title">&nbsp;{{ 'Längswelligkeitsmessungen' | mrTranslate }}</span>
                  </clr-button>
                  @if (
                    rechte() == 2 &&
                    objOpt?.Opt_F_Trassierung == 1 &&
                    authService?.token?.rights?.status > 2 &&
                    TRAEDIT == true
                  ) {
                    <clr-button
                      [clrInMenu]="q.matches || (!split50 && !expanded)"
                      (click)="setTrassierung()"
                      [disabled]="deactivateAll">
                      <cds-icon [title]="'Trassierungseditor' | mrTranslate" size="19" shape="bell-curve" />
                      <span class="clr-icon-title">&nbsp;{{ 'Trassierungseditor' | mrTranslate }}</span>
                    </clr-button>
                  }
                  <clr-button [clrInMenu]="q.matches || (!split50 && !expanded)" (click)="getMessungsUebersicht()">
                    <cds-icon [title]="'Messung Übersicht' | mrTranslate" size="20" shape="view-cards" />
                    <span class="clr-icon-title">&nbsp;{{ 'Messung Übersicht' | mrTranslate }}</span>
                  </clr-button>
                  <clr-button [clrInMenu]="q.matches || (!split50 && !expanded)" (click)="getMangelverteilung()">
                    <cds-icon [title]="'Mangel-/Bauformverteilung' | mrTranslate" size="19" shape="box-plot" />
                    <span class="clr-icon-title">&nbsp;{{ 'Mangel-/Bauformverteilung' | mrTranslate }}</span>
                  </clr-button>
                }
              }
              @if (
                rechte() == 2 &&
                objOpt?.Opt_O_UseKomponenten == 1 &&
                authService?.token?.rights?.status > 2 &&
                KOMEDIT == true &&
                !isRep
              ) {
                <clr-button [clrInMenu]="q.matches || (!split50 && !expanded)" (click)="getKomponenten()">
                  <cds-icon [title]="'Komponenten' | mrTranslate" size="20" shape="tree-view" solid="true" />
                  <span class="clr-icon-title">&nbsp;{{ 'Komponenten' | mrTranslate }}</span>
                </clr-button>
              }
              @if (objOpt?.Opt_O_UseRailProfil == 1) {
                <clr-button [clrInMenu]="q.matches || (!split50 && !expanded)" (click)="getRailmonitor()">
                  <cds-icon [title]="'Railmonitor' | mrTranslate" size="20" shape="line-chart" />
                  <span class="clr-icon-title">&nbsp;{{ 'Railmonitor' | mrTranslate }}</span>
                </clr-button>
              }
              @if (hasStellkraftmessung && objOpt?.Opt_F_Stellkraftmessung == 1 && !isRep) {
                <clr-button [clrInMenu]="q.matches || (!split50 && !expanded)" (click)="openStellkraftmessung()">
                  <cds-icon [title]="'Stellkraftmessung' | mrTranslate" size="20" shape="curve-chart" />
                  <span class="clr-icon-title">&nbsp;{{ 'Stellkraftmessung' | mrTranslate }}</span>
                </clr-button>
              }
              <!-- <ng-container *ngIf="hasStellkraftmessung && objOpt?.Opt_F_Stellkraftmessung == 1 && !isRep">
                      <clr-button [clrInMenu]="q.matches || (!split50 && !expanded)" (click)="openStellkraftCMS()">
                        <cds-icon [title]="'Stellkraftmessung-CMS' | mrTranslate" size="20" shape="curve-chart"></cds-icon>
                        <span class="clr-icon-title">&nbsp;{{'Stellkraftmessung-CMS' | mrTranslate}}</span>
                      </clr-button>
                    </ng-container> -->
              @if (excelPath) {
                <clr-button [clrInMenu]="q.matches || (!split50 && !expanded)" (click)="downloadExcelFile()">
                  <cds-icon [title]="'Excel' | mrTranslate" size="20" shape="file" />
                  <span class="clr-icon-title">&nbsp;{{ 'Excel' | mrTranslate }}</span>
                </clr-button>
              }
              @if (rechte() == 2 && opruefid !== 0 && optInterface > 100) {
                @if (!isFatObject()) {
                  <clr-button [clrInMenu]="q.matches || (!split50 && !expanded)" (click)="sendSAP()" [disabled]="isRep">
                    <cds-icon [title]="'SAP Export' | mrTranslate" size="20" shape="sap" />
                    <span class="clr-icon-title">&nbsp;{{ 'SAP Export' | mrTranslate }}</span>
                  </clr-button>
                }
              }
              @if (rechte() == 2 && opruefid !== 0) {
                @if (!isFatObject()) {
                  <clr-button
                    [clrInMenu]="q.matches || (!split50 && !expanded)"
                    (click)="getPDFFile()"
                    [disabled]="isRep">
                    <cds-icon [title]="'PDF' | mrTranslate" size="20" shape="pdffile" />
                    <span class="clr-icon-title">&nbsp;{{ 'PDF' | mrTranslate }}</span>
                  </clr-button>
                }
              }
            </ng-container>
          </clr-button-group>
        }
      </div>
      @if (ostammid && activeTab) {
        <clr-tabs dynamicOverflow class="w-100-p overflow-tab">
          <!-- Stammdaten -->
          <clr-tab class="w-100-p">
            <button clrTabLink (click)="tabChange('stammdaten')" [title]="'Stammdaten' | mrTranslate">
              {{ 'Stammdaten' | mrTranslate }}
            </button>
            <ng-template [(clrIfActive)]="activeTab['stamm']">
              <clr-tab-content>
                <div class="padding-10-t">
                  <strong class="caption nm">
                    {{ bezeichnung || ('Objekt' | mrTranslate) }}
                  </strong>
                  <app-image-slide-show [data]="files$ | async" />
                  <div>
                    @if (skizzeData) {
                      <span>{{ 'Messpunktskizze' | mrTranslate }}</span>
                      <br />
                      <app-image-slide-show [data]="[skizzeData]" invert height="25vh" />
                    }
                  </div>
                </div>
                @if (alv_date !== undefined) {
                  <div class="clr-row nxm padding-5-t">
                    <cds-icon shape="employee"></cds-icon>
                    <label style="margin-left: 15px">{{ 'ALV' | mrTranslate }}: {{ alv_name }}</label>
                    <label style="margin-left: 15px">{{ 'Datum' | mrTranslate }}: {{ alv_date | date }}</label>
                  </div>
                }
                @if (ebl_date !== undefined) {
                  <div class="clr-row nxm padding-5-t">
                    <cds-icon shape="administrator"></cds-icon>
                    <label style="margin-left: 15px">{{ 'EBL' | mrTranslate }}: {{ ebl_name }}</label>
                    <label style="margin-left: 15px">{{ 'Datum' | mrTranslate }}: {{ ebl_date | date }}</label>
                  </div>
                }
                @if (showKAV == true && kav.value && showProtected.kav) {
                  <div class="kavbar card">
                    <div class="kavbar-left">
                      <clr-checkbox-container class="clr-form-control" style="margin-top: 0px">
                        <clr-checkbox-wrapper>
                          <label>{{ 'KAV aktiv' | mrTranslate }}</label>
                          <input type="checkbox" clrCheckbox [(ngModel)]="kavaktiv" />
                        </clr-checkbox-wrapper>
                      </clr-checkbox-container>
                      @if (authService?.token?.rights?.status > 2 && kavaktiv) {
                        <button
                          type="button"
                          class="btn btn-sm btn-icon"
                          (click)="calKAV()"
                          [title]="'KAV berechnen' | mrTranslate">
                          <cds-icon shape="calculator"></cds-icon>
                        </button>
                      }
                    </div>
                    @if (kavaktiv) {
                      <div>
                        <span style="margin-right: 0.5em">{{ kav.value }}</span>
                        <cds-icon shape="circle" solid="true" [style.color]="kav.color"></cds-icon>
                      </div>
                    }
                  </div>
                }
                <!-- [style.height]="kav.value && showProtected.kav ? 'calc(100% - 130px)' : 'calc(100% - 80px)'" -->
                @if (tables['stamm'] !== undefined) {
                  <div style="overflow: auto">
                    <table class="table margin-0-t table-compact nowrap">
                      <thead>
                        <tr>
                          <th class="left" style="width: 25%">
                            {{ 'Objekt' | mrTranslate }}
                          </th>
                          <th class="left">
                            {{ 'Bezeichnung' | mrTranslate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of tables['stamm'].rows; track item) {
                          <tr>
                            @if (!item.isHeader) {
                              <td class="left">
                                {{ (item['Translate'] ? (item.Objekt | mrTranslate) : item.Objekt) | mrUnitText }}
                              </td>
                              <td class="left">{{ item.Bezeichnung | tablePrettyPrint: item.Objekt }}</td>
                            } @else {
                              <th class="headerRow left">
                                {{ item['Translate'] ? (item.Objekt | mrTranslate) : item.Objekt }}
                              </th>
                              <th class="headerRow"></th>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }

                @if (bemerkung?.length > 0) {
                  <h4>{{ 'Bemerkung' | mrTranslate }}:</h4>
                  <pre class="padding-3">{{ bemerkung }}</pre>
                }
                @if (bemerkung_pruefung?.length > 0) {
                  <h4>{{ 'Bemerkung zur Prüfung' | mrTranslate }}:</h4>
                  <pre class="padding-3">{{ bemerkung_pruefung }}</pre>
                }
              </clr-tab-content>
            </ng-template>
          </clr-tab>
          <!-- Spezifikation -->
          @if ((typ_Line_Point | objtype) == 'line' && tables['spez']) {
            <clr-tab class="w-100-p">
              <button clrTabLink (click)="tabChange('spez')" [title]="'Spezifikation' | titlecase | mrTranslate">
                {{ 'Spezifikation' | titlecase | mrTranslate }}
              </button>
              <ng-template [(clrIfActive)]="activeTab['spez']">
                <clr-tab-content>
                  <clr-datagrid
                    class="datagrid-compact dg-overflow-fix"
                    [clrDgSelectionType]="'single'"
                    [clrDgSelected]="[selectedSpez]"
                    (clrDgSelectedChange)="selectedSpez = $event[0]">
                    <clr-dg-column style="min-width: 50px; width: 50px">{{ 'Map' | mrTranslate }}</clr-dg-column>
                    @for (column of tables['spez'].columns; track column) {
                      <clr-dg-column [clrDgField]="column.id + '.value'">
                        <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: hideColumnsArr }">
                          {{ column.id | titlecase | mrUnitText }}
                        </ng-container>
                      </clr-dg-column>
                    }
                    <clr-dg-row *clrDgItems="let row of tables['spez'].rows" [clrDgItem]="row">
                      <clr-dg-cell style="min-width: 50px; width: 50px">
                        <a href="javascript:void(0);" (click)="previewMap(row)" disabled="!geometry">
                          <cds-icon shape="search" size="20" />
                        </a>
                      </clr-dg-cell>
                      @for (cell of tables['spez'].columns; track cell) {
                        <clr-dg-cell><app-dg-cell [data]="row[cell.id].value" [col]="cell.id" /></clr-dg-cell>
                      }
                    </clr-dg-row>
                    <clr-dg-footer>{{ tables['spez'].rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                  </clr-datagrid>
                </clr-tab-content>
              </ng-template>
            </clr-tab>
          }
          @if ((typ_Line_Point | objtype) == 'point' && tables['spez']) {
            <clr-tab class="w-100-p">
              <button clrTabLink (click)="tabChange('spez')" [title]="'Spezifikation' | titlecase | mrTranslate">
                {{ 'Spezifikation' | titlecase | mrTranslate }}
              </button>
              <ng-template [(clrIfActive)]="activeTab['spez']">
                <clr-tab-content>
                  <table class="table margin--3-t table-compact nowrap">
                    <thead>
                      <tr>
                        <th class="left" style="width: 25%">
                          {{ 'Objekt' | mrTranslate }}
                        </th>
                        <th class="left">{{ 'Bezeichnung' | mrTranslate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (item of tables['spez']; track item) {
                        <tr [hidden]="item.objekt == 'OSPEZID'">
                          @if (!item.isHeader) {
                            <td class="left">
                              {{ item.objekt | mrTranslate | mrUnitText }}
                            </td>
                            <td class="left">
                              {{ (item.fieldType == 'chk' ? !!item.bezeichnung : item.bezeichnung) | tablePrettyPrint }}
                            </td>
                          } @else {
                            <th class="headerRow left">
                              {{ item.objekt | mrTranslate }}
                            </th>
                            <th class="headerRow"></th>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </clr-tab-content>
              </ng-template>
            </clr-tab>
          }
          <!-- Komponenten -->
          @if (tables['komponenten']) {
            <clr-tab class="w-100-p">
              <button clrTabLink (click)="tabChange('komp')" [title]="'Komponenten' | titlecase | mrTranslate">
                {{ 'Komponenten' | titlecase | mrTranslate }}
              </button>
              <ng-template [(clrIfActive)]="activeTab['komp']">
                <clr-tab-content>
                  <clr-tree>
                    <clr-tree-node
                      *clrRecursiveFor="let item of rootObjekt; getChildren: getChildren"
                      [(clrExpanded)]="item.expanded">
                      <a class="clr-treenode-link" [class.active]="item == selnode" (click)="treeClick(item)">
                        {{ item.name }}
                      </a>
                      <!-- (click)="selectTreeNode(item)" -->
                      <!-- {{item.name}} -->
                    </clr-tree-node>
                  </clr-tree>
                  @if (spezData.length > 0) {
                    <div class="w-100-p scroll border-table margin-6-t">
                      <table class="table margin-0-t table-compact nowrap">
                        <thead>
                          <tr>
                            <th class="left">{{ 'Objekt' | mrTranslate }}</th>
                            <th class="left" style="width: 70%">
                              {{ 'Bezeichnung' | mrTranslate }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (spez of spezData; track spez) {
                            <tr [hidden]="spez.objekt == 'OSPEZID'">
                              <td class="left">
                                {{ spez.objekt | mrTranslate }}
                              </td>
                              <td class="left">
                                {{ spez.bezeichnung | mrTranslate }}
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                    <br />
                  }
                  <app-image-slide-show [data]="bilder" />
                  @if (kompHistoryData.rows?.length > 0) {
                    <br />
                    <strong>{{ 'Historie' | mrTranslate }}</strong>
                    <clr-datagrid class="datagrid-compact" style="margin-top: -10px">
                      @for (column of kompHistoryData.columns; track column) {
                        <clr-dg-column [clrDgField]="column.id">
                          <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: hideColumnsArr }">
                            {{ column.id | titlecase | mrTranslate }}
                          </ng-container>
                        </clr-dg-column>
                      }
                      <clr-dg-row *clrDgItems="let row of kompHistoryData.rows" [clrDgItem]="row">
                        @for (cell of kompHistoryData.columns; track cell) {
                          <clr-dg-cell><app-dg-cell [data]="row[cell.id]" [col]="cell.id" /></clr-dg-cell>
                        }
                      </clr-dg-row>
                      <clr-dg-footer>{{ kompHistoryData.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                    </clr-datagrid>
                  }
                </clr-tab-content>
              </ng-template>
            </clr-tab>
          }
          <!-- Mängel Gleis-->
          @if ((typ_Line_Point | objtype) == 'line' && tables['mangel']) {
            <clr-tab class="w-100-p">
              <button
                clrTabLink
                (click)="tabChange('mangel')"
                [hidden]="!tables['mangel']"
                [title]="'Mängel' | mrTranslate">
                {{ 'Mängel' | mrTranslate }}
              </button>
              <ng-template [(clrIfActive)]="activeTab['mangel']">
                <clr-tab-content>
                  <clr-datagrid class="datagrid-compact h-100" [clrDgItemsIdentityFn]="row => row?.OMAZSID">
                    <clr-dg-column class="mw-0">{{ 'Map' | mrTranslate }}</clr-dg-column>
                    <clr-dg-column class="mw-0">{{ 'Log' | mrTranslate }}</clr-dg-column>
                    <clr-dg-column class="mw-0">{{ 'Medien' | mrTranslate }}</clr-dg-column>
                    @for (column of tables['mangel'].columns; track column) {
                      <clr-dg-column [clrDgField]="column.id">
                        <ng-container
                          *clrDgHideableColumn="{
                            hidden: column.id | hideIDColumns: ['bildpfad', 'rueckbilder'],
                          }">
                          {{ column.id | titlecase | mrUnitText }}
                        </ng-container>
                      </clr-dg-column>
                    }
                    <clr-dg-row *clrDgItems="let row of tables['mangel'].rows" [clrDgItem]="row">
                      @if (!row.erledigtStatus && authService?.token?.rights?.status > 2) {
                        <clr-dg-action-overflow>
                          <button class="action-item" (click)="openBemerkung(row.bemerkung, row.OMAZSID)">
                            {{ 'Bemerkung eintragen' | mrTranslate }}
                          </button>
                          <button class="action-item" (click)="openSonderinspektion(row)">
                            {{ 'Sonderinspektion anlegen' | mrTranslate }}
                          </button>
                          @if (!row['LF']) {
                            <button class="action-item" (click)="openNewLA(row)">
                              {{ 'Langsamfahrstelle anlegen' | mrTranslate }}
                            </button>
                          }
                        </clr-dg-action-overflow>
                      }
                      <clr-dg-cell class="mw-0">
                        <a href="javascript:void(0);" (click)="previewMap(row)" disabled="!geometry">
                          <cds-icon shape="search" size="20" />
                        </a>
                      </clr-dg-cell>
                      <clr-dg-cell class="mw-0">
                        <a href="javascript:void(0);" (click)="mangelLog.set(row.OMAZSID)">
                          <cds-icon shape="view-list" size="20" />
                        </a>
                      </clr-dg-cell>
                      <clr-dg-cell class="mw-0">
                        <a
                          href="javascript:void(0);"
                          (click)="mangelMedia = media.parseMediaPath(row.bildpfad, row.rueckbilder)"
                          [class.deactivate]="!row.bildpfad && !row.rueckbilder">
                          <cds-icon [shape]="!row.bildpfad && !row.rueckbilder ? 'blank' : 'image-gallery'" size="20" />
                        </a>
                      </clr-dg-cell>
                      @for (cell of tables['mangel'].columns; track cell) {
                        <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                      }
                    </clr-dg-row>
                    <clr-dg-footer>{{ tables['mangel'].rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                  </clr-datagrid>
                </clr-tab-content>
              </ng-template>
            </clr-tab>
          }
          <!-- Mängel Punkt-->
          @if ((typ_Line_Point | objtype) == 'point' && tables['mangel']) {
            <clr-tab class="w-100-p">
              <button clrTabLink (click)="tabChange('mangel')" [title]="'mangel' | titlecase | mrTranslate">
                {{ 'mängel' | titlecase | mrTranslate }}
              </button>
              <ng-template [(clrIfActive)]="activeTab['mangel']">
                <clr-tab-content>
                  <clr-datagrid class="datagrid-compact" [clrDgItemsIdentityFn]="row => row?.OMAZSID">
                    <clr-dg-column class="mw-0">{{ 'Log' | mrTranslate }}</clr-dg-column>
                    <clr-dg-column class="mw-0">{{ 'Medien' | mrTranslate }}</clr-dg-column>
                    @for (column of tables['mangel'].columns; track column.id) {
                      <clr-dg-column [clrDgField]="column.id">
                        <ng-container
                          *clrDgHideableColumn="{
                            hidden: column.id | hideIDColumns: ['bildpfad', 'rueckbilder'],
                          }">
                          {{ column.id | titlecase | mrUnitText }}
                        </ng-container>
                      </clr-dg-column>
                    }
                    <clr-dg-row *clrDgItems="let row of tables['mangel'].rows" [clrDgItem]="row">
                      @if (!row.erledigtStatus && authService?.token?.rights?.status > 2) {
                        <clr-dg-action-overflow>
                          <button class="action-item" (click)="openBemerkung(row.bemerkung, row.OMAZSID)">
                            {{ 'Bemerkung eintragen' | mrTranslate }}
                          </button>
                          <button class="action-item" (click)="openSonderinspektion(row)">
                            {{ 'Sonderinspektion anlegen' | mrTranslate }}
                          </button>
                          @if (!row['LF']) {
                            <button class="action-item" (click)="openNewLA(row)">
                              {{ 'Langsamfahrstelle anlegen' | mrTranslate }}
                            </button>
                          }
                        </clr-dg-action-overflow>
                      }
                      <clr-dg-cell class="mw-0">
                        <a href="javascript:void(0);" (click)="mangelLog.set(row.OMAZSID)">
                          <cds-icon shape="view-list" size="20" />
                        </a>
                      </clr-dg-cell>
                      <clr-dg-cell class="mw-0">
                        <a
                          href="javascript:void(0);"
                          (click)="mangelMedia = media.parseMediaPath(row.bildpfad, row.rueckbilder)"
                          [class.deactivate]="!row.bildpfad && !row.rueckbilder">
                          <cds-icon [shape]="!row.bildpfad && !row.rueckbilder ? 'blank' : 'image-gallery'" />
                        </a>
                      </clr-dg-cell>
                      @for (cell of tables['mangel'].columns; track cell) {
                        <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                      }
                    </clr-dg-row>
                    <clr-dg-footer>{{ tables['mangel'].rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                  </clr-datagrid>
                </clr-tab-content>
              </ng-template>
            </clr-tab>
          }

          <!-- Messungen Punkt-->
          @if ((typ_Line_Point | objtype) == 'point' && (tables['messungen'] || tables['zaehler'])) {
            <clr-tab class="w-100-p container-size">
              <button clrTabLink (click)="tabChange('messungen')" [title]="'messungen' | titlecase | mrTranslate">
                {{ 'Messungen' | titlecase | mrTranslate }}
              </button>
              <ng-template [(clrIfActive)]="activeTab['messungen']">
                <clr-tab-content>
                  @if (tables['zaehler']) {
                    <div class="tablemessung">
                      <clr-accordion class="zaehlerAccordion" [clrAccordionMultiPanel]="true">
                        @if (tables['messungen']) {
                          <clr-accordion-panel>
                            <clr-accordion-title>{{ 'Messungen' | mrTranslate }}</clr-accordion-title>
                            <clr-accordion-content *clrIfExpanded>
                              <app-messung-grid
                                [ersterEintragMessung]="ErsterEintragMessung"
                                [name]="skizzeName"
                                [OPRUEFID]="messungsOPRUEFID"
                                [messungen]="tables['messungen']" />
                            </clr-accordion-content>
                          </clr-accordion-panel>
                        }
                        @for (panel of tables['zaehler'] | keyvalue; track panel.key) {
                          @let zaehler = panel.value;
                          <clr-accordion-panel>
                            <clr-accordion-title>{{ zaehler.Code }}</clr-accordion-title>
                            <clr-accordion-content *clrIfExpanded>
                              <app-zaehler-accordion [zaehler]="zaehler" />
                            </clr-accordion-content>
                          </clr-accordion-panel>
                        }
                      </clr-accordion>
                    </div>
                  } @else {
                    <app-messung-grid
                      [ersterEintragMessung]="ErsterEintragMessung"
                      [name]="skizzeName"
                      [OPRUEFID]="messungsOPRUEFID"
                      [messungen]="tables['messungen']" />
                  }
                </clr-tab-content>
              </ng-template>
            </clr-tab>
          }
          <!-- Dokumente -->
          @if (tables['dokheader'] && !isFatObject() && DOCEDIT) {
            <clr-tab class="w-100-p">
              <button clrTabLink (click)="tabChange('dokumente')" [title]="'dokumente' | titlecase | mrTranslate">
                {{ 'Dokumente' | titlecase | mrTranslate }}
              </button>
              <ng-template [(clrIfActive)]="activeTab['dokumente']">
                <clr-tab-content>
                  <div class="dokumenteControls btn-group btn-primary btn-sm padding-10-t wrap-button set-width">
                    <button class="btn" (click)="addDok()" [disabled]="isExternalOnlyCustomer()">
                      <cds-icon shape="plus" />
                      {{ 'Dokument' | mrTranslate }}
                    </button>
                    @if (authService?.token?.rights?.status == 6 || authService?.token?.rights?.dev == true) {
                      <button class="btn" (click)="addKategorie()" [disabled]="isExternalOnlyCustomer()">
                        <cds-icon shape="plus" />
                        {{ 'Kategorie' | mrTranslate }}
                      </button>
                      <button class="btn" (click)="editKategorie()" [disabled]="isExternalOnlyCustomer()">
                        <cds-icon shape="note" />
                        {{ 'Kategorie' | mrTranslate }}
                      </button>
                      @if (selAnzDok == 0) {
                        <button class="btn" (click)="delKategorie()" [disabled]="isExternalOnlyCustomer()">
                          <cds-icon shape="times" />
                          {{ 'Kategorie' | mrTranslate }}
                        </button>
                      }
                    }
                    <input
                      type="file"
                      id="fileUpload"
                      name="fileUpload"
                      multiple="multiple"
                      accept="{{ accept() }}"
                      style="display: none" />
                  </div>
                  <clr-tabs dynamicOverflow class="overflow-tab">
                    @for (tab of docheader; track tab; let i = $index) {
                      <clr-tab [attr.data-index]="i">
                        <button clrTabLink (click)="doctabChange(i)">
                          {{ tab }}
                        </button>
                        <clr-tab-content>
                          @if (docs.rows.length !== 0) {
                            <clr-datagrid
                              class="datagrid-compact"
                              [clrDgSelectionType]="'single'"
                              [clrDgSelected]="[selecteddocrow]"
                              (clrDgSelectedChange)="selecteddocrow = $event[0]; rowDocChanged($event[0])">
                              @for (column of docs.columns; track column) {
                                <clr-dg-column [clrDgField]="column.id">
                                  <ng-container
                                    *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: hideColumnsArr }">
                                    {{ column.id | titlecase | mrTranslate }}
                                  </ng-container>
                                </clr-dg-column>
                              }
                              <clr-dg-row *clrDgItems="let row of docs.rows" [clrDgItem]="row">
                                @if (!isExternalOnlyCustomer()) {
                                  <clr-dg-action-overflow>
                                    <button class="action-item" (click)="openDokument(row)">
                                      {{ 'Öffnen' | mrTranslate }}
                                    </button>
                                    <button class="action-item" (click)="deleteDokument(row)">
                                      {{ 'Löschen' | mrTranslate }}
                                    </button>
                                  </clr-dg-action-overflow>
                                }
                                @for (cell of docs.columns; track cell) {
                                  <clr-dg-cell><app-dg-cell [data]="row[cell.id]" [col]="cell.id" /></clr-dg-cell>
                                }
                              </clr-dg-row>
                              <clr-dg-footer>{{ docs.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                            </clr-datagrid>
                          } @else {
                            {{ 'Es sind keine Dokumente vorhanden' | mrTranslate }}
                          }
                        </clr-tab-content>
                      </clr-tab>
                    }
                  </clr-tabs>
                </clr-tab-content>
              </ng-template>
            </clr-tab>
          }
          @if (hasWebcamImages) {
            <clr-tab class="w-100-p">
              <button clrTabLink (click)="tabChange('streckenbilder')" [title]="'Streckenbilder' | mrTranslate">
                {{ 'Streckenbilder' | mrTranslate }}
              </button>
              <clr-tab-content *clrIfActive>
                <app-streckenbilder [opruefid]="opruefid" (pos)="changeGisPos($event)" />
              </clr-tab-content>
            </clr-tab>
          }
          @if (hasTrassierung) {
            <clr-tab class="w-100-p">
              <button clrTabLink (click)="tabChange('trassierung')" [title]="'Trassierung' | mrTranslate">
                {{ 'Trassierung' | mrTranslate }}
              </button>
              <clr-tab-content *clrIfActive>
                <app-trassierung
                  [resize$]="resize$"
                  [ostammid]="ostammid"
                  [trassierungtable]="trassierungtable"
                  [baseStartMeter]="baseStartMeter"
                  [baseEndMeter]="baseEndMeter" />
              </clr-tab-content>
            </clr-tab>
          }
          <!-- Logbuch -->
          @if (objOpt?.Opt_F_Logbuch) {
            <clr-tab class="w-100-p">
              <button clrTabLink (click)="tabChange('logbuch')" [title]="'Logbuch' | mrTranslate">
                {{ 'Logbuch' | mrTranslate }}
              </button>
              <clr-tab-content *clrIfActive>
                <app-logbuch [ostammid]="ostammid" />
              </clr-tab-content>
            </clr-tab>
          }
          <!-- Historie -->
          <clr-tab class="w-100-p">
            <button
              clrTabLink
              (click)="tabChange('historie')"
              [disabled]="!showProtected.history"
              [title]="'Historie' | mrTranslate">
              {{ 'Historie' | mrTranslate }}
            </button>
            <clr-tab-content>
              @if (initTab['historie']) {
                <app-historie-tree [ostammid]="ostammid" />
              }
            </clr-tab-content>
          </clr-tab>
          <!-- Statistik -->
          @if (tables['anlagenstatistik'] && !isFatObject()) {
            <clr-tab class="w-100-p">
              <button clrTabLink (click)="tabChange('statistic')" [title]="'Statistik' | mrTranslate">
                {{ 'Statistik' | mrTranslate }}
              </button>
              <clr-tab-content>
                @if (graphkavelemente?.length > 0) {
                  <div
                    class="clr-row"
                    style="margin-left: 10px; margin-right: 10px; margin-top: 5px; min-height: 125px">
                    @for (item of graphkavelemente; track item) {
                      <div class="clr-col">
                        <app-plotly-plot
                          [className]=""
                          [data]="item.data"
                          [layout]="item.layout"
                          [config]="item.config" />
                      </div>
                    }
                  </div>
                }
                @if (kavstatistic?.length > 0) {
                  <div
                    class="clr-row"
                    style="margin-left: 10px; margin-right: 10px; margin-top: -15px; min-height: 250px">
                    <div class="clr-col-12">
                      <div class="card">
                        <h3 class="card-header d-flex justify-content-between align-items-center">KAV Entwicklung</h3>
                        <div class="card-block">
                          <app-plotly-plot
                            [className]=""
                            [data]="kavstatistic"
                            [layout]="graphkav0.layout"
                            [config]="graphkav0.config"
                            [resizeSubject]="resize$" />
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (dia_kav_spez?.data.length > 0) {
                  <div
                    class="clr-row"
                    style="margin-left: 10px; margin-right: 10px; margin-top: -15px; min-height: 250px">
                    <div class="clr-col-12">
                      <div class="card">
                        <h3 class="card-header d-flex justify-content-between align-items-center">
                          KAV - Spezifikation
                        </h3>
                        <div class="card-block">
                          <app-plotly-plot
                            [className]=""
                            [data]="dia_kav_spez.data"
                            [layout]="dia_kav_spez.layout"
                            [config]="dia_kav_spez.config"
                            [resizeSubject]="resize$" />
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div
                  class="clr-row"
                  style="margin-left: 10px; margin-right: 10px; margin-top: -15px; min-height: 250px">
                  <div class="clr-col-12">
                    <div class="card">
                      <h3 class="card-header d-flex justify-content-between align-items-center">
                        {{ 'FK nach Inspektion' | mrTranslate }}
                      </h3>
                      <div class="card-block">
                        @if (fkninsp?.length > 0) {
                          <app-plotly-plot
                            [className]=""
                            [data]="dia_fkninsp.data"
                            [layout]="dia_fkninsp.layout"
                            [config]="dia_fkninsp.config"
                            [resizeSubject]="resize$" />
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="clr-row"
                  style="margin-left: 10px; margin-right: 10px; margin-top: -15px; min-height: 250px">
                  <div class="clr-col-12">
                    <div class="card">
                      <h3 class="card-header d-flex justify-content-between align-items-center">
                        {{ 'Mängel instand gesetzt' | mrTranslate }}
                      </h3>
                      <div class="card-block">
                        @if (fknih?.length > 0) {
                          <app-plotly-plot
                            [className]=""
                            [data]="dia_fknih.data"
                            [layout]="dia_fknih.layout"
                            [config]="dia_fknih.config"
                            [resizeSubject]="resize$" />
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="clr-row"
                  style="margin-left: 10px; margin-right: 10px; margin-top: -15px; min-height: 250px">
                  <div class="clr-col-12">
                    <div class="card">
                      <h3 class="card-header d-flex justify-content-between align-items-center">
                        {{ 'Instandsetzungquote pro Fehlerklasse in %' | mrTranslate }}
                      </h3>
                      <div class="card-block">
                        @if (ih_qoute.length > 0) {
                          <app-plotly-plot
                            [className]=""
                            [data]="dia_ih_qoute.data"
                            [layout]="dia_ih_qoute.layout"
                            [config]="dia_ih_qoute.config"
                            [resizeSubject]="resize$" />
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="clr-row"
                  style="margin-left: 10px; margin-right: 10px; margin-top: -15px; min-height: 250px">
                  <div class="clr-col-12">
                    <div class="card">
                      <h3 class="card-header d-flex justify-content-between align-items-center">
                        {{ 'Instandsetzungsdauer pro Fehlerklasse in Tagen' | mrTranslate }}
                      </h3>
                      <div class="card-block">
                        @if (ih_average.length > 0) {
                          <app-plotly-plot
                            [className]=""
                            [data]="dia_ih_average.data"
                            [layout]="dia_ih_average.layout"
                            [config]="dia_ih_average.config"
                            [resizeSubject]="resize$" />
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </clr-tab-content>
            </clr-tab>
          }
          <!-- Restliche Tabellen -->
          @for (table of tables | keyvalue | array: 'filter' : getRestTabellen; track table) {
            @if (!(isFatObject() && table.key === 'teilerneuerung')) {
              <clr-tab class="w-100-p">
                <button
                  clrTabLink
                  (click)="tabChange(table.key)"
                  [title]="
                    table.key == 'spez' ? ('Spezifikation' | mrTranslate) : (table.key | titlecase | mrTranslate)
                  ">
                  {{ table.key == 'spez' ? ('Spezifikation' | mrTranslate) : (table.key | titlecase | mrTranslate) }}
                </button>
                <ng-template [(clrIfActive)]="activeTab[table.key]">
                  <clr-tab-content>
                    <clr-datagrid class="datagrid-compact">
                      @if (table.key == 'bauwerke' || table.key == 'naturschutz') {
                        <clr-dg-column style="min-width: 40px; width: 40px">{{ 'Map' | mrTranslate }}</clr-dg-column>
                      }
                      @if (table.key == 'bauwerke' || table.key == 'naturschutz') {
                        <clr-dg-column style="min-width: 40px; width: 40px">{{ 'Medien' | mrTranslate }}</clr-dg-column>
                      }
                      @for (column of table.value?.columns; track column) {
                        <clr-dg-column [clrDgField]="column.id">
                          <ng-container
                            *clrDgHideableColumn="{
                              hidden: column.id | hideIDColumns: hideColumnsArr,
                            }">
                            {{ column.id | titlecase | mrTranslate }}
                          </ng-container>
                        </clr-dg-column>
                      }
                      <clr-dg-row *clrDgItems="let row of table.value?.rows">
                        @if (table.key == 'bauwerke' || table.key == 'naturschutz') {
                          <clr-dg-cell style="min-width: 40px; width: 40px">
                            <a href="javascript:void(0);" (click)="previewMap(row)" disabled="!geometry">
                              <cds-icon shape="search" size="20" />
                            </a>
                          </clr-dg-cell>
                        }
                        @if (table.key == 'bauwerke' || table.key == 'naturschutz') {
                          <clr-dg-cell style="min-width: 40px; width: 40px">
                            <a
                              href="javascript:void(0);"
                              (click)="bauwerksMedia = bauwmedia.parseMediaPath(row.bild)"
                              [class.deactivate]="!row.bild">
                              <cds-icon [shape]="!row.bild ? 'blank' : 'image-gallery'" />
                            </a>
                          </clr-dg-cell>
                        }
                        @for (cell of table.value?.columns; track cell) {
                          <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                        }
                      </clr-dg-row>
                      <clr-dg-footer>{{ table.value?.rows?.length ?? 0 }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                    </clr-datagrid>
                  </clr-tab-content>
                </ng-template>
              </clr-tab>
            }
          }
          <!-- Mangelskizzen -->
          @if ((typ_Line_Point | objtype) == 'point' && objOpt?.Opt_F_Drawing == 1 && !isRep) {
            <clr-tab class="w-100-p">
              <button clrTabLink (click)="tabChange('paint')" [title]="'Mangelskizzen' | mrTranslate">
                {{ 'Mangelskizzen' | mrTranslate }}
              </button>
              <clr-tab-content *clrIfActive>
                <app-painting [setostammid]="ostammid" [setinittyp]="'1'" [setUserStatus]="userstatus.toString()" />
              </clr-tab-content>
            </clr-tab>
          }
        </clr-tabs>
      }
      @if (mangelLog()) {
        <app-mangel-log-modal [(omazsid)]="mangelLog" />
      }
    </div>
  }
</div>

<app-sonderinspektionmodal />

<!-- Modalfenster "Hersteller" -->
@if (isHerstellDatenVisible) {
  <app-herstell-daten-modal
    (onClose)="closeHerstellModal($event)"
    [disable]="deactivateAll || deactivateRep || isExternalOnlyCustomer()"
    [ospezid]="selectedSpezID" />
}

<clr-modal [(clrModalOpen)]="isKatVisible" [clrModalClosable]="true">
  <h3 class="modal-title">{{ TitelKat }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="vertical">
      <div class="clr-row">
        <div class="clr-col-12">
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 250px">
              <input
                id="_group_name_new"
                class="clr-input combobox"
                placeholder="{{ 'Kategorie' | mrTranslate }}"
                name="_alias"
                #kategorie />
            </div>
          </div>
          <br />
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="saveKategorie()">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="isKatVisible = false">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

@if (mangelMedia) {
  <app-mediaviewmodal
    (onClose)="mangelMedia = undefined"
    [srcs]="mangelMedia"
    [getMediaFromServerAll]="media.getApiFunctionMedia"
    [getBigFileFnc]="media.getApiFunctionMediaBig"
    (openPdfOverlay)="openPdf($event)" />
}

@if (bauwerksMedia) {
  <app-mediaviewmodal
    (onClose)="bauwerksMedia = undefined"
    [srcs]="bauwerksMedia"
    [getMediaFromServerAll]="bauwmedia.getApiFunctionMedia"
    [getBigFileFnc]="bauwmedia.getApiFunctionMediaBig"
    (openPdfOverlay)="openPdf($event)" />
}

@if (dokumentenMedia()) {
  <app-mediaviewmodal (onClose)="dokumentenMedia.set(undefined)" [media]="dokumentenMedia()" />
}

<clr-modal [(clrModalOpen)]="showbemerkung">
  <h3 class="modal-title">{{ 'Bemerkung eintragen' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm>
      <clr-textarea-container style="margin-top: -10px">
        <textarea
          id="aa"
          class="clr-col-md-12"
          [placeholder]="'Tragen Sie hier die Bemerkung für den Mangel ein' | mrTranslate"
          clrTextarea
          [(ngModel)]="mangelbemerkung"
          name="bemerkung"
          required
          style="width: 100%; height: 150px"></textarea>
      </clr-textarea-container>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="saveMangelBemerkung()">
      {{ 'Bemerkung speichern' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="showGIS" [clrModalSize]="'lg'">
  <h3 class="modal-title">{{ 'GIS Map' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm>
      <div style="width: 100%; height: 580px">
        <div id="previewMap" style="width: 100%; height: 100%; z-index: 2"></div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="showGIS = false">
      {{ 'Schließen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<!-- TODO: Verwendung bei Stammarchivierung, wenn das mal gemacht wird -->
<!-- <app-mediaviewmodal *ngIf="anlagenMedia"
              (onClose)="anlagenMedia = undefined"
              [srcs]="anlagenMedia"
              [getMediaFromServerAll]="anlMedia.getApiFunctionMedia"
              [getBigFileFnc]="anlMedia.getApiFunctionMediaBig"/> -->
